import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	dialogContent: {
		flex: 'unset'
	},
	dialogActions: {
		justifyContent: 'center',
		paddingBottom: '40px'
	},
	openNotification: {
		color: theme.palette.common.white
	},
	closeModal: {
		width: '8rem',
		height: '3rem',
		borderRadius: 0
	}
}));

export default useStyles;
